<template>
  <div class="app" v-if="showApp">
    <div v-if="$store.getters['authModule/isAuthenticated']" class="app-wrapper">
      <loading-overlay-component v-if="showLoadingOverlay" />
      <!-- Navbar -->
      <pix-navbar v-if="showNavbar" />
      <!-- Sidebar -->
      <pix-sidebar />
      <!-- Content -->
      <div class="app-content body-content no-padding">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
    <pix-audit-log-modal />
  </div>
</template>

<script>
/* Imports */
// import pixNavbar from './home/pixNavbar.vue';
import pixNavbar from '@/components/home/pixNavbar/pixNavbar.vue';
import pixAuditLogModal from './common/audit/pixAuditLogModal.vue';
import loadingOverlayComponent from './common/loadingOverlayComponent.vue';
import { mapGetters } from 'vuex';
import pixSidebar from '@/components/common/sidebar/pix-sidebar.vue';

/* Controller */
export default {
  name: 'app',

  components: {
    pixSidebar,
    pixNavbar,
    pixAuditLogModal,
    loadingOverlayComponent,
  },

  computed: {
    ...mapGetters({
      showLoadingOverlay: 'loadingOverlayModule/getIsLoading',
      showNavbar: 'getTranslationIsLoaded',
      showApp: 'getShowApp',
    }),
  },
};
</script>

<style>
html,
body {
  height: 100vh;
  overflow: hidden;
}

div.app {
  height: 100vh;
  /* padding-top: var(--navbar-height); */
}

div.page {
  height: calc(100vh - var(--navbar-height));
}

div.page > .container-fluid {
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.no-padding {
  padding: 0;
}

.app-wrapper {
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: var(--navbar-height) 1fr;
}

.app-content {
  overflow-y: auto;
}

.highlight {
  background: #ffff00;
}
</style>
